import type { ScaledLine } from './soldLineAmounts';

export type AmountBasis = 'net' | 'gross';

export const ACCOUNT_BALANCE_LABEL = 'Account balance';

export const AMOUNT_BASIS_LABELS: Record<AmountBasis, { column: string; total: string; balance: string; vat: string }> = {
    net: { column: 'Net', total: 'Total (ex VAT)', balance: ACCOUNT_BALANCE_LABEL, vat: 'ex VAT' },
    gross: { column: 'Gross', total: 'Total (inc VAT)', balance: 'Available balance (inc VAT)', vat: 'inc VAT' },
};

export const scaledAmount = (line: ScaledLine, basis: AmountBasis): number => line[basis];
